import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { batch } from 'react-redux'

import { message } from 'antd'

// Constants and Config
import { PACKAGE } from '../../../constants'

// Services
import { closeWS, subscribeWS } from '../../websocket';

// Redux Action
import { get_all_subscription_packages_request } from './subscriptionPackages'
import { user_role_get_request } from './userRoles'
// import { user_hierarchy_get_request } from './userHierarchy'
import { get_user_info_cms_request } from "./liveCamera";
import {
    setLoadingGeneral,
    unsetLoadingGeneral
} from './style';
import {
    get_vehicle_groups_request,
    // get_vehicles_by_vehicle_group_relation_request
} from './vehicleGroups'
import {
    get_device_groups_request,
    // get_devices_by_device_group_relation_request
} from './deviceGroups'
import {
    get_device_mdvr_groups_request,
} from './deviceMDVRGroups'
import {
    get_driver_groups_request
} from './driverGroups'
import {
    get_geofence_templates_request
} from './geofenceTemplates'
import {
    get_rule_templates_request
} from './ruleTemplates'
import {
    get_maintenance_templates_request
} from './maintenanceConfigs'
import {
    get_all_plus_cctv_section_request
} from './surveillances'
import {
    get_vam_line_templates_request
} from './vamLines'
// import {
//     get_vam_programs_request
// } from './vamPrograms'

// Neccessary Actions
import { auth_user_sign_out } from '../../../../main/services/redux/actions/user'
import { get_devices_state_cms_request } from "./devicesMDVR";

const {
    ACCOUNT_PACKAGE_OWNERSHIP
} = PACKAGE

export const user_sign_in_request = uid => dispatch => {
    dispatch(setLoadingGeneral())

    batch(() => {
        dispatch(get_all_subscription_packages_request())
        dispatch(get_user_info_cms_request(user => {
            dispatch(get_devices_state_cms_request(uid, user.SessionId))
        }))
    })

    API
    .getInfoByUser(uid)
    .then(info => {

        if (info.errorType === 'ValidationException') {
            message.error('Error. Refresh page?');
        }
        else {
            const {
                accountPackages,
                asset,
                user
            } = info;

            batch(() => {

                if(user) {
                    dispatch(user_sign_in_success(user));
                    dispatch(user_role_get_request(user.uroleid))
                    // dispatch(user_hierarchy_get_request(user, user.hierCode))

                    if(user.porgid === ACCOUNT_PACKAGE_OWNERSHIP.AXIATA) {
                        dispatch(get_all_plus_cctv_section_request())
                    }
                    
                    subscribeWS({
                        ids: [uid],
                        uid: uid
                    })
                }
    
                if(accountPackages) {
                    dispatch(user_account_package_get_success(accountPackages))
                }

                if(asset) {
    
                    const {
                        devgids,
                        drvgids,
                        vhcgids,
                        geotids,
                        ruletids,
                        maintids,
                        vamltids,
                        // vampids
                        mdvrgids
                    } = asset
        
                    if(vhcgids) {
                        dispatch(get_vehicle_groups_request(vhcgids, uid))
                        // dispatch(get_vehicles_by_vehicle_group_relation_request(vhcgids, uid))
                    }
                    if(devgids) {
                        dispatch(get_device_groups_request(devgids, uid))
                        // dispatch(get_devices_by_device_group_relation_request(devgids, uid))
                    }
                    if(mdvrgids) dispatch(get_device_mdvr_groups_request(mdvrgids, uid))
                    if(drvgids) dispatch(get_driver_groups_request(drvgids, uid))
                    if(geotids) dispatch(get_geofence_templates_request(geotids, uid))
                    if(ruletids) dispatch(get_rule_templates_request(ruletids, uid))
                    if(maintids) dispatch(get_maintenance_templates_request(maintids))
                    if(vamltids) dispatch(get_vam_line_templates_request(vamltids))
                    // if(vampids) dispatch(get_vam_programs_request(vampids))
    
                }

            })
        }
    })
    .finally(() => {
        dispatch(unsetLoadingGeneral())
    })
}

const user_sign_in_success = (user) => {
    return {
        type: ActionTypes.USER_SIGN_IN,
        user
    };
}

const user_account_package_get_success = (accountPackages) => {
    return {
        type: ActionTypes.USER_ACCOUNT_PACKAGES_GET,
        accountPackages
    }
}

export const user_sign_out_request = (cb = () => {}) => dispatch => {
    closeWS();
    batch(() => {
        dispatch(auth_user_sign_out(cb))
        dispatch(user_sign_out_success())
    })
}

const user_sign_out_success = () => {
    return {
        type: ActionTypes.USER_SIGN_OUT
    };
}

// export const user_profile_update_request = (items, cb = () => {}) => dispatch => {

//     API
//     .cuUser({
//         action: 'U',
//         ...items
//     })
//     .then(info => {
        
//         const { user, status, msg } = info
        
//         if(status === 200) {
//             dispatch(user_profile_update_success(user))
//             cb()
//         } else if(status === 401) {
//             message.warning(`Failed in updating user. ${msg}`)
//         } else {
//             message.warning(`Failed in updating user. Retry?`)
//         }


//     })
// }

// const user_profile_update_success = (user) => {
//     return {
//         type: ActionTypes.USER_PROFILE_UPDATE,
//         user
//     };
// }

// export const get_vehicle_by_uid_request = (uid) => dispatch => {
//     API
//     .getInfoByUser(uid)
//     .then(info => {
//         const { asset } = info

//         if(asset) {
//             const {
//                 vhcgids,
//                 devgids
//             } = asset

//             if(vhcgids) {
//                 dispatch(get_vehicles_by_vehicle_group_relation_request(vhcgids, uid))
//                 dispatch(get_vehicle_groups_request(vhcgids, uid))
//             }
            
//             if(devgids) {
//                 dispatch(get_devices_by_device_group_relation_request(devgids, uid))
//                 dispatch(get_device_groups_request(devgids, uid))
//             }
//         }
//     })

// }